import React from "react";
import { useTranslation } from "components/translations/useTranslation";
import { Button, ButtonType } from "components/common/Button.component";
import { MODAL_CONTENT_TAB_INDEX } from "utils/constants";
import { navigateToMyTasks } from "components/router/router.function.js";
import { HandledTaskProps } from "types/modals";

const HandledTask = ({ closeModal, loopFocus, more, initialFocusRef }: HandledTaskProps): React.ReactElement => {
    const { translate } = useTranslation();

    return (
        <>
            <div className="ga-modal__content">
                <span>{translate("popUp.handledTaskWarning.message")}</span>
            </div>
            <div className="ga-modal__actions">
                <Button
                    type={ButtonType.PRIMARY}
                    onClick={closeModal}
                    ref={initialFocusRef}
                    tabIndex={MODAL_CONTENT_TAB_INDEX}
                    text={translate("popUp.handledTaskWarning.Close")}
                />
                {!more?.hideClose && (
                    <Button
                        type={ButtonType.SECONDARY}
                        onClick={navigateToMyTasks}
                        tabIndex={MODAL_CONTENT_TAB_INDEX + 1}
                        text={translate("popUp.handledTaskWarning.goToTasks")}
                        onBlur={loopFocus}
                    />
                )}
            </div>
        </>
    );
};

export default HandledTask;
